import { useQuery } from '@tanstack/react-query';

import { sstPatternsApi } from '@/services';

export const sstPatternsKeys = { all: ['sst', 'patterns'] as const };

export function useSstPatternsQuery(enabled = true) {
  return useQuery({ queryKey: sstPatternsKeys.all, queryFn: () => sstPatternsApi.list(), enabled });
}
